import React from "react";
import Timeline from "./Timeline";
import WhatWillDo from "./WhatWillDo";
import UpcomingWebinar from "./UpcomingWebinar";
import Underline from "../../../assets/underlines/2.png";
import Misc1 from "../../../assets/misc/6.svg";
import Misc2 from "../../../assets/misc/4.svg";
import Misc3 from "../../../assets/misc/13.svg";

const Competition = () => {
  return (
    <div className="sm:max-w-container max-w-[90vw] mx-auto mb-[150px] relative z-10">
      <div className="flex justify-center items-center mb-[100px] relative">
        <div className="flex flex-col items-center sm:w-[75%] md:w-full">
          <p className="uppercase font-semibold text-sm text-warning leading-5 mb-8 text-center">
            competition
          </p>
          <p className="font-semibold md:text-5xl text-4xl md:leading-[64px] mx-auto leading-[48px] text-dark text-center">
            What is the competition?
          </p>
        </div>
        <div >
          <img
            src={Misc1}
            className="absolute top-16 right-[5%] lg:block hidden"
            alt=":( Not Found"
          />
          <img
            src={Misc3}
            className="absolute sm:top-[50%] top-[100%] w-[10%] right-[3%] min-w-[60px] max-w-[80px] lg:hidden block"
            alt=":( Not Found"
          />
        </div>
      </div>
      <div className="flex flex-col items-center bg-white rounded-[48px] lg:px-[106px] px-[2vw] md:pt-[120px] pt-[90px] pb-[150px]">
        <div className="relative flex flex-col items-end mb-16">
          <img
            src={Misc2}
            className="absolute -top-[1.5rem] -left-[5rem] md:block hidden"
            alt=":( Not Found"
          />
          <p className="font-semibold md:text-[40px] text-3xl leading-tight text-dark mb-2 text-center">
            How does the competition work?
          </p>
          <img src={Underline} alt=":( Not Found" className="w-[min(275px,85%)] mx-auto sm:mx-0 md:w-[325px] sm:w-[275px]" />
        </div>
        <Timeline />
        <WhatWillDo />
        <UpcomingWebinar />
      </div>
    </div>
  );
};

export default Competition;
